__turbopack_context__.v({
  "chatInputWrapper": "AiChatPanel-module-scss-module__FEIXTG__chatInputWrapper",
  "messagesWrapper": "AiChatPanel-module-scss-module__FEIXTG__messagesWrapper",
  "root": "AiChatPanel-module-scss-module__FEIXTG__root",
});
